import { Component, OnInit, ViewEncapsulation, OnDestroy, Output, EventEmitter } from '@angular/core';

import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { TranslateService } from "@ngx-translate/core";
import { Router } from '@angular/router';
import { FormValidationComponent } from '../../../form-validation/form-validation.component';
import { AjaxService } from '../../../services/ajax.service';
import { Utility } from '../../../shared/utility/utility';
import { CustomValidators } from '../../../shared/utility/custom-validator';
import { EmitterService } from '../../../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ChangePasswordComponent extends FormValidationComponent implements OnInit, OnDestroy {
  focusedElement;
  changePasswordForm = this.formBuilder.group({
    'old': ['', [this.CustomValidators.reqMin(1)]],
    // 'passwords': this.formBuilder.group({
    'password': ['', [this.CustomValidators.validatePassword(8)]],
    'confirmPassword': ['', [this.CustomValidators.validatePassword(8)]],
  }, { validator: this.CustomValidators.passwordConfirming })
  // });
  formSubmitted: boolean = false;
  changePasswordSuccess: boolean = false;
  serverError;
  isPwdOld: boolean = false;
  isPwdNew: boolean = false;
  isPwdNewconf: boolean = false;
  focusPassword = false;
  langCode;
  isSubmitted = false;
  @Output() triggerAccountMenu = new EventEmitter<{}>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  

  constructor(private ajaxService: AjaxService,
    private utils: Utility,
    private formBuilder: FormBuilder,
    private CustomValidators: CustomValidators,
    private emitterService: EmitterService,
    private translationService: TranslateService,
    private router:Router

  ) {
    super(utils);
    this.changePasswordSuccess = false;
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
      
    })
  }

  ngOnInit() {
    this.changePasswordSuccess = false;
  }
  @Output() close = new EventEmitter();
  gotoMyAccount() {
    if (document.body.clientWidth <= 992) {
      this.close.emit();
    }else{
      this.router.navigate([this.langCode + '/myaccount'])
    }
    
  }
  // changePasswordStatus() {
  //   this.changePasswordSuccess = false;
  //   this.isPwdNew = false;
  //   this.isPwdNewconf = false;
  //   this.isPwdOld= false;
  //   this.utils.resetFormFields(this.changePasswordForm);
  //   this.utils.removeAllFormFieldsvalidation(this.changePasswordForm);
  // }
  getButtonClass(formName, fieldName) {
    return this.utils.getButtonClass(formName, fieldName)
  }
  isButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }
  trimPassowrd(){
    let oldPass = this.changePasswordForm.controls["old"].value;
    let newPass = this.changePasswordForm.controls["password"].value;
    let confirmPass = this.changePasswordForm.controls["confirmPassword"].value;
    this.changePasswordForm.controls["old"].setValue(oldPass.trim())
    this.changePasswordForm.controls["password"].setValue(newPass.trim())
    this.changePasswordForm.controls["confirmPassword"].setValue(confirmPass.trim());
  }
  changePassword(buttonId): void {
    this.isSubmitted = true;
    this.utils.disableNewButton(buttonId);
    //this.utils.disableButton(buttonId);
    let errorDiv = "#serverErrorChangePassword";
    $(errorDiv).addClass("hide");
    this.formSubmitted = true;
    if (this.changePasswordForm.valid) {
      let data = this.utils.formControlToParams(this.changePasswordForm, {});
      Promise.resolve(this.ajaxService.changePassword(data))
        .then(regData => {
          if (regData && regData["success"] && regData["success"]["status"] === "SUCCESS") {
            this.changePasswordSuccess = true;
            this.utils.enableNewButton(buttonId, "SUCCESS", "Success", "Save Changes");
            this.utils.resetFormFields(this.changePasswordForm);
            this.utils.removeAllFormFieldsvalidation(this.changePasswordForm);


            setTimeout(() => {
              this.changePasswordSuccess = false;
              if (document.body.clientWidth <= 992) {
                this.close.emit();
              }
              // this.router.navigate(['/myaccount'])
              // $("#modal").modal("hide");
            }, 5000);

            // setTimeout(function(){
            //   self.changePasswordSuccess = false;
            //   $("#successTick").toggleClass("success-tick");
            //   $("#formFields").toggleClass("hide-form-fields");
            // },3000)
          } else if (regData && regData["errors"] && regData["errors"]["message"]) {
            this.utils.showError(errorDiv);
            this.serverError = regData["errors"]["message"];
            this.emitterService.broadcastserverError(this.serverError, "");
            this.utils.enableNewButton(buttonId, "FAILED", "Failed", "Save Changes");
          } else {
            this.utils.showError(errorDiv);
            this.serverError = this.translationService.instant('errors.error');
            // this.serverError = "Something Went Wrong. Please try again later";
            this.emitterService.broadcastserverError(this.serverError, "");
            this.utils.enableNewButton(buttonId, "FAILED", "Failed", "Save Changes");
          }
          this.formSubmitted = false;
          //this.utils.enableButton(buttonId);
        },
          SystemError => {
            this.utils.showError(errorDiv);
            this.serverError = this.translationService.instant('errors.error');
            // this.serverError = "Something Went Wrong. Please try again later"
            //this.utils.enableButton(buttonId);
            this.utils.enableNewButton(buttonId, "FAILED", "Failed", "Save Changes");
            this.formSubmitted = false;
            this.emitterService.broadcastserverError(this.serverError, "")
          });
    } else {
      this.utils.validateAllFormFields(this.changePasswordForm);
      //this.utils.enableButton(buttonId);
      this.utils.enableNewButton(buttonId, "", "Save Changes", "Save Changes");
    }
  }
  getValidFormContols(formGroup: FormGroup, validControls) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl && control.valid && field != this.focusedElement) {
        validControls.push(field)
      } else if (control instanceof FormGroup) {
        this.getValidFormContols(control, validControls);
      }
    });
    return validControls;
  }

  shouldShowPwdError(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName)
  }

  goBack(){
      this.triggerAccountMenu.emit(true);
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  
}
